import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';

import { IAction } from '~/src/store';

import { ECitySelect } from './index';

export type TSetTopCities = IAction<ECitySelect.SET_TOP_CITIES, ICitySatellite[]>

const setTopCities = (topCities: ICitySatellite[]): TSetTopCities => ({
    type: ECitySelect.SET_TOP_CITIES,
    payload: topCities,
});

export default setTopCities;
